import { AlertTriangle, Loader2, Trash2 } from "lucide-react";
import { useState } from "react";
import { Button } from "src/components/ui/button";
import { BaseUrlApi, ErrorMessage } from "src/lib/api";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/ui/dialog";
import { Input } from "src/components/ui/input";
import axios from "axios";
import { toast } from "sonner";
import { useLanguage } from "src/context/LanguageContext";
import { SubLessonData } from "../../../../../../lib/languages";

export const DialogDeleteAnswer = ({ item, fetchAnswers }) => {
  const { language } = useLanguage();
  const t = SubLessonData[language] || SubLessonData.en;

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmText, setConfirmText] = useState("");

  const confirmationWord = t.confirmationWord;
  const isConfirmEnabled = confirmText.toUpperCase() === confirmationWord;

  const handleDeleteHomeWork = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.delete(`${BaseUrlApi}/answer-assignments/${item.bid}`);
      toast(t.deleteAnswerTitle, {
        description: t.deleteAnswer + " " + "has been successfully removed 🗑️",
      });
      await fetchAnswers();
      setOpen(false);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="text-red-500 h-7 w-7">
          <Trash2 className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent
        className="sm:max-w-md"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <DialogHeader className="gap-2">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-red-500" />
            <DialogTitle className="text-red-500">
              {t.deleteAnswerTitle} "{item.title || "---"}"
            </DialogTitle>
          </div>
          <DialogDescription>{t.dialogDeleteDescription}</DialogDescription>
        </DialogHeader>

        <div className="space-y-2">
          <label htmlFor="confirm" className="text-sm font-medium">
            {t.typeToConfirmDelete}
          </label>
          <Input
            id="confirm"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder={confirmationWord}
            className={
              !isConfirmEnabled
                ? "border-destructive focus-visible:ring-0"
                : "border-green-500 focus-visible:ring-0"
            }
          />
        </div>

        <DialogFooter className="sm:justify-between gap-2">
          <DialogClose asChild>
            <Button type="button" variant="outline">
              {t.cancel}
            </Button>
          </DialogClose>
          <Button
            type="button"
            variant="destructive"
            onClick={handleDeleteHomeWork}
            disabled={loading || !isConfirmEnabled}
            className="gap-2"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <>
                <Trash2 className="h-4 w-4" />
                {t.deleteAnswer}
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
